module.exports = __webpack_public_path__ + "img/home_img_person2.86c72f3c.png";